/**
 * Trims the whitespace from the start of a string
 * @param str The string to trim
 */
import escapeRegExp from './escapeRegExp';
import { empty, WHITESPACE } from './_consts';
export default function trimStart(str, chars) {
    if (chars !== undefined) {
        chars = escapeRegExp(chars);
    }
    else {
        chars = WHITESPACE;
    }
    const regex = new RegExp(`^[${chars}]+`, 'g');
    return str.replace(regex, empty);
}
